module.exports = __webpack_public_path__ + "media/images/exchange/gift-50d7b0bd41f04a9aa4b948ec18cff01a.svg";